import { render, staticRenderFns } from "./GameScreen.vue?vue&type=template&id=77a25ac9&scoped=true&"
import script from "./GameScreen.vue?vue&type=script&lang=js&"
export * from "./GameScreen.vue?vue&type=script&lang=js&"
import style0 from "./GameScreen.vue?vue&type=style&index=0&id=77a25ac9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a25ac9",
  null
  
)

export default component.exports